import Color from "color";
import colors from "PFTheme/tokens/colors";

import { kpmgVariables } from "../themes/kpmg";
import legacyColors from "../themes/legacy_colors";

const themes = {
  profinda: {}, // profind theme is now the same as the default theme!
  kpmg: kpmgVariables
};

type ThemeMode = "Light" | "Dark";

const stripThemeSuffix = (source: Record<string, string>, mode: ThemeMode): Record<string, string> =>
  Object.entries(source)
    .filter(([key]) => key.endsWith(mode))
    .reduce((acc, [key, value]) => {
      const newKey = key.slice(0, -mode.length);
      acc[newKey] = value;
      return acc;
    }, {});

export const getThemeVars = (theme: string, mode: ThemeMode): Record<string, string> => {
  const allVarsWithClientTheme = {
    ...legacyColors,
    ...colors,
    ...themes[theme]
  };
  return stripThemeSuffix(allVarsWithClientTheme, mode);
};

const parseColor = (value: string): ReturnType<typeof Color> | null => {
  try {
    return new Color(value);
  } catch {
    return null;
  }
};

export const getColorStyles = (theme: string = "profinda") => {
  const addRgb = (tokens: Record<string, string>) =>
    Object.entries(tokens).reduce((acc, [key, value]) => {
      acc[key] = value;

      const color = parseColor(value);
      if (color) {
        acc[`${key}RGB`] = `${color.red()} ${color.green()} ${color.blue()}`;
      }
      return acc;
    }, {});

  const darkTokens = addRgb(getThemeVars(theme, "Dark"));
  const lightTokens = addRgb(getThemeVars(theme, "Light"));

  const rootStyles = `:root {\n${Object.entries(lightTokens)
    .map(([key, value]) => `  --${key}: ${value};`)
    .join("\n")}\n}`;

  const darkStyles = `[data-theme="dark"] {\n${Object.entries(darkTokens)
    .map(([key, value]) => `  --${key}: ${value};`)
    .join("\n")}\n}`;

  return {
    rootStyles,
    darkStyles
  };
};
